/**
 * What to say when the backend refuses a SuperAdmin action with 503 because its
 * SuperAdmin audit trail is switched off ("SuperAdmin actions are unavailable
 * because they cannot be audited."). That is a server configuration problem,
 * not user error, and retrying will not help, so the copy sends the user to
 * support rather than asking them to try again.
 *
 * Shared by User Management (`user-management-error-codes.util.ts`) and My
 * Profile's password change (`change-password-errors.util.ts`): the backend
 * returns the same 503 for both.
 */
export const SUPERADMIN_AUDIT_UNAVAILABLE_MESSAGE =
  'This action is temporarily unavailable. Please contact support.';
